import type { SupportTicketListItemResponse } from "@redotech/effect-api-shared/models/shopper-ai/conversation/support-ticket";
import DotsVerticalIcon from "@redotech/redo-icons/dots-vertical.svg";
import {
  DropdownMenu,
  DropdownMenuTrigger,
} from "@redotech/redo-web/components/ui/dropdown-menu";
import { memo, useCallback } from "react";
import { SupportTicketActionsDropdown } from "../../../actions/support-ticket-actions-dropdown";
import { useSupportTicketsTableContext } from "../../support-tickets-table-context";

interface SupportTicketActionsMenuProps {
  supportTicket: SupportTicketListItemResponse;
}

export const SupportTicketActionsMenu = memo(function SupportTicketActionsMenu({
  supportTicket,
}: SupportTicketActionsMenuProps) {
  const { actionMenuOpenForId, setActionMenuOpenForId } =
    useSupportTicketsTableContext();

  const isOpen = actionMenuOpenForId === supportTicket.id;
  const setIsOpen = useCallback(
    (open: boolean) => setActionMenuOpenForId(open ? supportTicket.id : null),
    [setActionMenuOpenForId, supportTicket.id],
  );

  const handleClose = useCallback(() => setIsOpen(false), [setIsOpen]);

  return (
    <DropdownMenu onOpenChange={setIsOpen} open={isOpen}>
      <DropdownMenuTrigger
        className="flex h-8 w-8 items-center justify-center rounded hover:bg-gray-100"
        onClick={(e) => e.stopPropagation()}
      >
        <DotsVerticalIcon className="h-4 w-4" />
      </DropdownMenuTrigger>
      <SupportTicketActionsDropdown
        isOpen={isOpen}
        onClose={handleClose}
        supportTicket={supportTicket}
        supportTicketId={supportTicket.id}
      />
    </DropdownMenu>
  );
});
